module.exports = __webpack_public_path__ + "public/1.0.1_626420/img/71.33f52e28.png";